




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ToPay, ToPayItem } from '@/api'
import formatter from '@/helpers'

@Component
export default class FinancePayList extends Vue {
  @Prop() list!: ToPay
  @Prop(String) name!: string
  @Prop(String) payType!: string

  formatDate (val: string | undefined): string {
    return formatter.formatDateNear(val)
  }

  filterType (): Array<ToPayItem> {
    const filtered: Array<ToPayItem> = []

    this.list.list.forEach(val => {
      if (val.order.user.pay_type === this.payType) {
        filtered.push(val)
      }
    })

    return filtered
  }
}
